import * as api from '../api';
import {GET_REVIEW,CREATEREVIEW,DELETE} from '../constants/actionTypes'



export const getReview = ()=> async (dispatch)=> {
    
    try {
        const {data} = await api.fetchReviews();
        
        
        // console.log(api.fetchPosts());
        dispatch({type: GET_REVIEW,payload: data});
    } catch (error) {
        console.log(error.message);
    }

}


export const createReview = (ReviewData) => async (dispatch) =>{
    try {
        const {data} = await api.createReviews(ReviewData);

        dispatch({type:CREATEREVIEW,payload: data})
    } catch (error) {
        console.log(error);
    }
}

export const deleteReview = (id) => async (dispatch) => {
    try {
      await api.deleteReview(id);
  
      dispatch({ type: DELETE, payload: id });
    //   navigate('/admin/messages');
    } catch (error) {
      console.log(error.message);
    }
  };